import React from "react";
import Slider from "react-slick";
import Navbar from "../../../layout/Navbar";
import Footer from "../../../layout/Footer";
import FireClayImage from "../../../assets/Our Products/Refractory Bricks/FireClay Bricks/IS-8-BRICKS.jpeg";
import dataSheetImg from "../../../assets/Our Products/Refractory Bricks/FireClay Bricks/data-fire-clay-bricks.png";
import Slider1 from "../../../assets/Our Products/Refractory Bricks/FireClay Bricks/IS-8-FIRE-CLAY-BRICKS-1.jpeg";
import Slider2 from "../../../assets/Our Products/Refractory Bricks/FireClay Bricks/IS-8-FIRE-CLAY-BRICKS-2.jpeg";
import Slider3 from "../../../assets/Our Products/Refractory Bricks/FireClay Bricks/IS-8-FIRE-CLAY-BRICKS-3.jpeg";
import Slider4 from "../../../assets/Our Products/Refractory Bricks/FireClay Bricks/IS-8-FIRE-CLAY-BRICKS-4.jpeg";
import Slider5 from "../../../assets/Our Products/Refractory Bricks/FireClay Bricks/IS-8-FIRE-CLAY-BRICKS-5.jpeg";
import Slider6 from "../../../assets/Our Products/Refractory Bricks/FireClay Bricks/IS-8-FIRE-CLAY-BRICKS-6.jpeg";
import Slider7 from "../../../assets/Our Products/Refractory Bricks/FireClay Bricks/IS-8-FIRE-CLAY-BRICKS-7.jpeg";
import Slider8 from "../../../assets/Our Products/Refractory Bricks/FireClay Bricks/IS-8-FIRE-CLAY-BRICKS-8.jpeg";
import Slider9 from "../../../assets/Our Products/Refractory Bricks/FireClay Bricks/IS-8-FIRE-CLAY-BRICKS-9.jpeg";
import Slider10 from "../../../assets/Our Products/Refractory Bricks/FireClay Bricks/IS-8-FIRE-CLAY-BRICKS-10.jpeg";
import Slider11 from "../../../assets/Our Products/Refractory Bricks/FireClay Bricks/IS-8-FIRE-CLAY-BRICKS-11.jpeg";
import Slider12 from "../../../assets/Our Products/Refractory Bricks/FireClay Bricks/IS-8-FIRE-CLAY-BRICKS-12.jpeg";
import Slider13 from "../../../assets/Our Products/Refractory Bricks/FireClay Bricks/IS-8-FIRE-CLAY-BRICKS-13.jpeg";
import Slider14 from "../../../assets/Our Products/Refractory Bricks/FireClay Bricks/IS-8-FIRE-CLAY-BRICKS-14.jpeg";
import Slider15 from "../../../assets/Our Products/Refractory Bricks/FireClay Bricks/IS-8-FIRE-CLAY-BRICKS-15.jpeg";


const FireClay_Bricks = () => {

  const sliderImages = [
    Slider1, Slider2, Slider3, Slider4, Slider5, Slider6, Slider7, Slider8, Slider9, Slider10, Slider11, Slider12, Slider13, Slider14, Slider15
  ];

  // Responsive slider settings
    const sliderSettings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 1000,
        arrows: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    arrows: true,
                }
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                }
            }
        ]
    };

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />

      {/* About Fire Clay Bricks Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 gap-10 items-center">
          {/* Text Section */}
          <div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              About <span className="text-orange-600">Fire Clay Bricks</span>
            </h2>
            <p className="text-lg text-gray-700 leading-relaxed mb-4">
              JANTA Group is specialize in manufacturing Refractory Fire Clay Bricks from quality raw materials. Our Fire Clay Bricks are developed with various proportions of B.D., C.C.S, P.C.E and porosity. Our collection of Refractory Fire Bricks is globally accepted for high compression ratio, high tensile strength and good uniformity. Our Refractory Fire Bricks can withstand high heat and temperature. We are well reckoned as one of the flourishing Fire Clay Bricks Manufacturers and Suppliers based in India. We provide Refractory Fire Bricks within the stipulated time frame at very competitive rate.
            </p>
          </div>

          {/* Image Section */}
          <div className="flex justify-center md:justify-end relative">
            <img
              src={FireClayImage}
              alt="Fire Clay Bricks"
              className="w-80 h-80 object-cover rounded-2xl shadow-2xl"
            />
          </div>
        </div>
      </section>

      {/* Data Sheet Section */}
      <section className="py-16 bg-gradient-to-br from-gray-900 to-gray-800 text-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl sm:text-4xl font-bold mb-10">
            Product Data Sheet for <span className="text-orange-500">Fire Clay Bricks</span>
          </h2>

          <div className="flex justify-center">
            <img
              src={dataSheetImg}
              alt="Fire Clay Bricks Data Sheet"
              className="rounded-1xl shadow-2xl border border-white/20 w-full sm:w-[80%] md:w-[70%] object-contain"
            />
          </div>
        </div>
      </section>

      {/* Area of Application Section */}
      <section className="py-16 bg-gray-100">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center">
            Area Of Application
          </h2>
          <ul className="list-disc list-inside text-lg text-gray-700 space-y-2">
            <li>Cast iron foundries</li>
            <li>Rolling Mills</li>
            <li>Lancashire Boilers</li>
            <li>Rice Mills</li>
            <li>Mini Steel Plants / Boiler Arches</li>
            <li>High Pressure Boilers</li>
            <li>Checkers of open hearth furnaces</li>
            <li>Oil fired furnaces</li>
            <li>Glass Factories</li>
          </ul>
        </div>
      </section>

      {/* Auto Image Slider Section */}
      <section className="py-8 sm:py-16 bg-[#0b032d] text-white relative overflow-hidden">
  <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
    <div className="relative flex justify-center overflow-hidden rounded-2xl">
      
      <div className="slider w-full sm:w-2/3 h-[260px] sm:h-[250px]">
        <div className="w-full">
          <Slider {...sliderSettings}>
            {sliderImages.map((image, index) => (
              <div key={index} className="px-2 sm:px-2">
                <img
                  src={image}
                  alt={`Slide ${index + 1}`}
                  className="h-[260px] sm:h-[200px] lg:h-[250px] w-full object-contain rounded-lg shadow-md"
                />
              </div>
            ))}
          </Slider>
        </div>
      </div>

    </div>
  </div>
</section>


      <style jsx>{`
        @keyframes slide {
          0% { transform: translateX(0); }
          33% { transform: translateX(-260px); }
          66% { transform: translateX(-520px); }
          100% { transform: translateX(0); }
        }
        .animate-slide {
          animation: slide 8s infinite linear;
        }
      `}</style>

      <Footer />
    </div>
  );
};

export default FireClay_Bricks;
